import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import moment from 'moment'

// Keep the language on moment.js in sync with i18next
// by listening to the change language event.
i18n.on('languageChanged', (newlocale) => moment.locale(newlocale))

export const i18nInitPromise = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    fallbackLng: 'en',
    // Load 'en' instead of 'en-US' (strip region code)
    load: 'languageOnly',
    // Namespaces loaded on init (minimal for fast startup)
    // Other namespaces are loaded on-demand by useTranslation/withTranslation
    ns: ['commons'],
    defaultNS: 'commons',
    fallbackNS: 'commons',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator']
    },
    lookupQuerystring: 'lng',
    caches: ['localStorage', 'cookie'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format) => {
        if (value instanceof Date) return moment(value).format(format)
        return value
      }
    },
    // See https://github.com/i18next/i18next-http-backend
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Prevent browser caching of locale files
      queryStringParams: { v: Date.now() }
    }
  })

export default i18n
